import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-375faba5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main--rain-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main--rain-panel__meter" }, null, -1))
const _hoisted_3 = { class: "main--rain-panel__controller" }
const _hoisted_4 = { class: "main--rain-panel__controller__time-slider rain-slider" }
const _hoisted_5 = { class: "main--rain-panel__controller__speed-slider rain-slider" }
const _hoisted_6 = { class: "main--rain-panel__controller__timer" }
const _hoisted_7 = { class: "rain-time" }
const _hoisted_8 = { class: "controls" }

import { ref, computed, watch } from 'vue'
import Slider from '@/components/top/Slider.vue'
import { min, max } from 'lodash'
import moment from 'moment'
import { useGpvStore } from '@/stores/gpvStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const MAX_SLIDER_VALUE = 41
const MIN_SLIDER_VALUE = 0

const speed = ref<number>(50)
const autoplay = ref<boolean>(false)
const timer = ref<number | undefined>()
const sliderValue = ref<number>(24)

const gpvStore = useGpvStore()
const baseTime = computed(() => gpvStore.nowcast?.baseTime)

const interval = computed(() => (1000 * 100) / speed.value)

const rainTimeNext = () => {
  sliderValue.value++
  sliderValue.value = min([sliderValue.value, MAX_SLIDER_VALUE]) as number

  if (sliderValue.value == MAX_SLIDER_VALUE) {
    autoplay.value = false
  }

  resetTimer()
}

const rainTimePrev = () => {
  sliderValue.value--
  sliderValue.value = max([sliderValue.value, MIN_SLIDER_VALUE]) as number
  resetTimer()
}
const setTimer = () => {
  timer.value = setTimeout(() => {
    rainTimeNext()
  }, interval.value)
}
const resetTimer = () => {
  timer.value && clearTimeout(timer.value)
  autoplay.value && setTimer()
}

const toggleAutoPlay = () => {
  autoplay.value = !autoplay.value
  if (autoplay.value) {
    rainTimeNext()
    setTimer()
  } else {
    timer.value && clearTimeout(timer.value)
  }
}

const displayTime = computed(() => {
  let tmpBaseTime = baseTime.value
  let offsetMinute = (sliderValue.value - 24) * 5
  // 36より上は1時間以上で短時間降水量を使用する。
  if (sliderValue.value > 36) {
    offsetMinute = (sliderValue.value - 36 + 1) * 60
    tmpBaseTime = gpvStore.srf?.baseTime ? gpvStore.srf.baseTime : tmpBaseTime
  }
  return moment(tmpBaseTime).add(offsetMinute, 'minute').format('YYYY年MM月DD日 HH:mm')
})

const setForecastTime = async () => {
  await gpvStore.fetchTime()

  let tmpBaseTime = baseTime.value
  let offsetMinute = (sliderValue.value - 24) * 5
  if (sliderValue.value > 36) {
    offsetMinute = (sliderValue.value - 36 + 1) * 60
    tmpBaseTime = gpvStore.srf?.baseTime ? gpvStore.srf.baseTime : tmpBaseTime
  }
  gpvStore.setBaseTime(tmpBaseTime as string)
  gpvStore.setForcastTime(moment(tmpBaseTime).add(offsetMinute, 'minute').toISOString())
}

watch(() => gpvStore.nowcast?.baseTime, setForecastTime, { immediate: true })

watch(() => sliderValue.value, setForecastTime, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Slider, {
          max: MAX_SLIDER_VALUE,
          modelValue: sliderValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sliderValue).value = $event)),
          style: {"width":"345px","margin-left":"-7px","margin-top":"4px"}
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Slider, {
          max: 100,
          min: 30,
          modelValue: speed.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((speed).value = $event)),
          style: {"width":"95px","margin-left":"-2px","margin-top":"-4px"}
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(displayTime)), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          id: "rain-panel__autoplay",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleAutoPlay()))
        }),
        (autoplay.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              id: "rain-panel__pause",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleAutoPlay()))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          id: "rain-panel__btn__prev",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (rainTimePrev()))
        }),
        _createElementVNode("button", {
          id: "rain-panel__btn__next",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (rainTimeNext()))
        })
      ])
    ])
  ]))
}
}

})